import { FC } from "react";
import { Form as FormikForm, FormikProvider, useFormik } from "formik";
import * as Yup from "yup";
import { useGatheringsRsvpMutation } from "~/store/api";
import { RsvpCta } from "./RsvpCta";

const validationSchema = Yup.object({
  slug: Yup.string().required("Required"),
});

interface Props {
  onOpen: () => void;
  rsvped: boolean | null | undefined;
  slug: string;
}

export const RsvpForm: FC<Props> = ({ onOpen, rsvped, slug }) => {
  const [apiGatheringsRsvp] = useGatheringsRsvpMutation();

  const initialValues = {
    slug: slug,
  };

  const onSubmit = async (): Promise<void> => {
    onOpen();
    await apiGatheringsRsvp({ slug });
  };

  const formik = useFormik({
    initialValues,
    onSubmit,
    validateOnMount: true,
    validationSchema,
  });

  if (rsvped) {
    return null;
  }

  return (
    <FormikProvider value={formik}>
      <FormikForm>
        <RsvpCta />
      </FormikForm>
    </FormikProvider>
  );
};
